enum BoxesDialogFields {
	MODE = 'mode',
	TYPE = 'type',
	WIDTH = 'width',
	HEIGHT = 'height',
	MARGIN_LEFT = 'margin_left',
	MARGIN_TOP = 'margin_top',
	PAGERANGE = 'pagerange'
}

export default BoxesDialogFields;